import { Flex, Stack } from '@chakra-ui/react';
import { DiscountCode } from '@time-line/components/common';
import type { Cost as CostType } from 'types/cart/Cost';
import type { DiscountAllocation } from 'types/cart/DiscountAllocation';

import { Price } from '../Price';

interface CartLineItemCostProps {
  cost: Omit<CostType, 'totalTaxAmount'>;
  discountAllocations: DiscountAllocation[];
  isMobile?: boolean;
}

function Cost({ cost, discountAllocations, isMobile }: CartLineItemCostProps) {
  return (
    <>
      {cost && (
        <Price
          subtotalAmount={cost.subtotalAmount}
          totalAmount={cost.totalAmount}
          direction={isMobile ? 'row' : 'row-reverse'}
        />
      )}
      {discountAllocations.map((discount, i) => (
        <DiscountCode key={`${discount.code}-${i}`} size="sm">
          {discount.code}
        </DiscountCode>
      ))}
    </>
  );
}

export function CartLineItemCost({
  isMobile,
  ...props
}: CartLineItemCostProps) {
  return isMobile ? (
    <Flex
      display={{ base: 'flex', md: 'none' }}
      alignItems={{ base: 'flex-start', sm: 'center' }}
      flexDirection={{ base: 'column', sm: 'row' }}
      mb="3xs"
      gap="4xs"
    >
      <Cost {...props} isMobile />
    </Flex>
  ) : (
    <Stack
      display={{ base: 'none', md: 'flex' }}
      alignItems="flex-end"
      spacing="4xs"
      flexShrink={0}
    >
      <Cost {...props} />
    </Stack>
  );
}
